export const TRIGGER_USER_DETAILS = "TRIGGER_USER_DETAILS";
export const TRIGGER_LEAD_DETAILS = "TRIGGER_LEAD_DETAILS";
export const TRIGGER_REVIEW_APPLICATION_DETAILS =
  "TRIGGER_REVIEW_APPLICATION_DETAILS";

export const TRIGGER_CURRENT_COUNTRY = "TRIGGER_CURRENT_COUNTRY";

export const TRIGGER_CREDIT_SCORE = "TRIGGER_CREDIT_SCORE";
